module.exports = "table{width:100%}mat-form-field{padding:20px}mat-spinner{margin:auto}.fa-pencil{margin-right:15px}\n"